// Iter161 · Muestra los últimos errores REALES de cron (post-misfire) con
// KPI de últimos 7 días. Se refresca cada 60 s.
import React, { useState, useEffect } from "react";
import axios from "axios";
import { AlertTriangle, Loader2, RefreshCw } from "lucide-react";
import { API } from "@/context/AuthContext";

export default function CronErrorsPanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${API}/admin/cron-errors?limit=25`);
      setData(r.data);
    } catch (e) {
      setData({ items: [], kpis: { total_last7d: 0, by_job_last7d: [] } });
    } finally { setLoading(false); }
  };
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  const items = data?.items || [];
  const total = data?.kpis?.total_last7d || 0;

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5" data-testid="cron-errors-section">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <AlertTriangle size={18} className={total > 0 ? "text-rose-600" : "text-gray-400"}/>
          <div>
            <h3 className="font-bold text-gray-900 font-['Outfit']">Errores reales de cron</h3>
            <p className="text-xs text-gray-500 mt-0.5">
              Fallos de ejecución (no misfires por reinicio). Rate-limit: 1 email/hora por job.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className={`text-xl font-bold tabular-nums ${total > 0 ? "text-rose-700" : "text-gray-400"}`} data-testid="cron-errors-total-7d">{total}</span>
          <span className="text-[10px] text-gray-400 uppercase">/7d</span>
          <button onClick={load} className="text-gray-400 hover:text-gray-700 p-1" data-testid="cron-errors-refresh"><RefreshCw size={13}/></button>
        </div>
      </div>

      {loading ? (
        <div className="py-6 text-center text-gray-400 text-sm inline-flex items-center gap-2 w-full justify-center">
          <Loader2 size={13} className="animate-spin"/> Cargando…
        </div>
      ) : items.length === 0 ? (
        <div className="py-6 text-center text-emerald-600 text-sm border-2 border-dashed border-emerald-200 rounded-lg bg-emerald-50/40" data-testid="cron-errors-empty">
          ✅ Sin errores reales de cron registrados
        </div>
      ) : (
        <div className="space-y-1.5 max-h-64 overflow-y-auto">
          {items.map((e, i) => (
            <div key={i} className="text-xs flex items-start gap-2 p-2 rounded border border-rose-200 bg-rose-50/40" data-testid={`cron-error-row-${i}`}>
              <span className="font-mono text-[10px] text-gray-500 tabular-nums whitespace-nowrap">{(e.ts || "").slice(0, 16).replace("T", " ")}</span>
              <span className="font-bold text-rose-800 bg-rose-100 px-1.5 py-0.5 rounded uppercase text-[10px] whitespace-nowrap">{e.job_id}</span>
              <span className="font-mono text-[10px] text-gray-600 whitespace-nowrap">{e.exception_type}</span>
              <span className="text-gray-700 flex-1 truncate" title={e.message}>{e.message}</span>
              {e.email_sent && <span className="text-[9px] text-emerald-700 whitespace-nowrap">✉ enviado</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
